import apiConfig from "../config/api";
import { get, post } from "../helpers/request";
// import datamock from "../components/SucursalVirtual/Trabajador/Siniestros/Prestaciones/datamock.json";

const apiLosses = `${apiConfig.apiUri}api/losses`;
const apiFiles = `${apiConfig.apiUri}api/file`;
const apiDraftLosses = `${apiConfig.apiUri}api/losses/financialbenefits/draft`;
const getToken = () => localStorage.getItem("AccessToken");


export const getPrestacionesApi = (rut, skip, take, filter) =>
  fetch(`${apiLosses}/financialbenefits/${rut}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
  });

export const getLastPrestacionesApi = (rut) =>
  fetch(`${apiLosses}/financialbenefits/last/${rut}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
  });

export const GetDraftDocument = (employeeRut, companyRut, userRut, idFinancialBenefit) =>
  fetch(`${apiDraftLosses}/${employeeRut}/${companyRut}/${userRut}/${idFinancialBenefit}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
  });


export const CreateDraftDocuments = (Data) =>
  fetch(`${apiDraftLosses}/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: `EmployeeRut=${Data.Rut}&CompanyRut=${Data.CompanyRut}&JsonData=${Data.jsonData}&UserRut=${Data.UserRut}&idFinancialBenefit=${Data.idFinancialBenefit}`
  });

export const DeleteDraftComplaint = (IdDraftFinancialBenefit) =>
  fetch(`${apiDraftLosses}/delete/${IdDraftFinancialBenefit}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    }
  });

export const UpdateDraftDocument = (Data) =>
  fetch(`${apiDraftLosses}/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: `EmployeeRut=${Data.Rut}&CompanyRut=${Data.CompanyRut}&JsonData=${Data.jsonData}&UserRut=${Data.UserRut}&idFinancialBenefit=${Data.idFinancialBenefit}`
  });

export const doUploadDocumentApi = (Data) =>
  fetch(`${apiFiles}/uploadFiles`, {
    method: "POST",
    headers: {
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Accept: "/",
      "accept-encoding": "gzip, deflate",
    },
    body: Data,

  });

export const doGetDocumentsApi = (rutTrabajador, idPrestacion) =>
  get(`${apiFiles}/documents/${rutTrabajador}/${idPrestacion}`);

export const doGetUploadDraftDocumentApi = (rutUsuario, rutTrabajador, idPrestacion) =>
  fetch(`${apiFiles}/draftDocuments/${rutUsuario}/${rutTrabajador}/${idPrestacion}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
  });
export const doDeleteFileApi = (data) =>
  fetch(`${apiFiles}/deleteFile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(data),
  });

export const doDeleteContainerApi = (data) =>
  fetch(`${apiFiles}/deleteContainer`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(data),
  });

export const sendDraftApi = (data) =>
// NOTE: LOCAL API DEBUGGER
  fetch(`${apiLosses}/financialbenefits/create`, {
  // fetch(`https://localhost:44317/api/losses/financialbenefits/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(data),
  });

export const GetPrestacionEconomicaPDFApi = (idSiniestro,nombreTrabajador, rutTrabajador) => get(`${apiLosses}/financialbenefits/pdf/${idSiniestro}/${nombreTrabajador}/${rutTrabajador}`);

// NOTE: LOCAL API DEBUGGER
// export const GetPrestacionEconomicaPDFApi = (idSiniestro,nombreTrabajador, rutTrabajador) => get(`https://localhost:44317/api/losses/financialbenefits/pdf/${idSiniestro}/${nombreTrabajador}/${rutTrabajador}`);


export const MovePrestacionesFiles = (IdPrestacion, RutTrabajador, RutUsuario, IdSiniestro, IsNewPrestacion) =>
  post(`${apiFiles}/moveFiles`, {
    body: JSON.stringify({
      IdPrestacion,
      RutUsuario,
      RutTrabajador,
      IdSiniestro,
      IsNewPrestacion,
    })
  });
